import { BaseApiService } from "../services/baseApiService";
import ShowNotifications from "../utils/notification";
class CategoryProvider extends BaseApiService {
  constructor() {
    super();
  }

  async addCategory(input) {
    try {
      const response = await this.post("/categories", input, "Category created successfully");

      if (response.status == 200 || response.status == 201) {
        return {
          status: true,
        };
      } else {
        return {
          status: false,
          message: response?.data?.message || "Failed to create category",
        };
      }
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || "Failed to create category";
      return {
        response: null,
        status: false,
        message: msg,
      };
    }
  }
  async getCategorylist() {
    try {
      const response = await this.get("/categories");

      if (response.status == 200 || response.status == 201) {
        return {
          status: true,
        };
      } else {
        return {
          status: false,
        };
      }
    } catch (err) {
      return {
        response: null,
        status: false,
      };
    }
  }
  async getCategory(input) {
    return await this.get("/categories", input);
  }

  async updateCategory(id, input) {
    try {
      const response = await this.put(`/categories/${id}`, input, "Category updated successfully")
      if (response.status == 200 || response.status == 201) {
        return {
          status: true,
          response: response.data
        }
      } else {
        return {
          status: false,
          message: response?.data?.message || "Failed to update category",
        }
      }
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message || "Failed to update category";
      return {
        response: null,
        status: false,
        message: msg,
      }
    }
  }

  async deleteCategory(id) {
    try {
      const response = await this.delete(`/categories/${id}`, "Category deleted successfully");

      if (response.status == 200 || response.status == 201) {
        // Redundant call removed as BaseApiService now handles it with the custom message
        return {
          response: response.data,
          status: true,
        };
      } else {
        return {
          status: false,
        };
      }
    } catch (error) {
      return {
        response: null,
        status: false,
      };
    }
  }

}

export default new CategoryProvider();
